// @ts-check
/** @type {Record<PreMedRoute, string>} */
export const preMedDrugRoutes = {
  PO: 'PO',
  SL: 'SL',
  IM: 'IM',
  IN: 'Intranasal',
  PR: 'Rectal',
  SC: 'Subcutaneous',
  TD: 'Transdermal',
  BUC: 'Buccal',
  OR: 'Oral Rinse',
  INH: 'Inhalation',
  TOP: 'Topical',
  OPH: 'Ophthalmic',
}

/** @type {PreMedRoute[]} */
// @ts-ignore
export const preMedDrugRouteIds = Object.keys(preMedDrugRoutes)
